//
//
//
//
//
//
//
//

export default {
  name: 'icon',

  props: {
    large: Boolean,

    left: Boolean,

    medium: Boolean,

    right: Boolean,

    xLarge: Boolean
  },

  computed: {
    classes () {
      return {
        'icon--large': this.large,
        'icon--left': this.left,
        'icon--medium': this.medium,
        'icon--right': this.right,
        'icon--x-large': this.xLarge
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/icons/Icon.vue